import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "comp-form",
  id: "CreatePage",
  "dark-class": "comp-form-dark"
}
const _hoisted_2 = ["id"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["id", "data-step-id"]
const _hoisted_5 = { class: "title-box" }
const _hoisted_6 = { class: "serial-number" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = {
  key: 0,
  class: "step-content"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "prompt" }, "密码必须包含 1 个字母和 1 个数字，密码长度至少为 8 个字符，如需修改密码时输入任意字符或删除任意字符即可", -1)
const _hoisted_10 = { class: "form-box" }
const _hoisted_11 = {
  key: 1,
  class: "step-content"
}
const _hoisted_12 = {
  key: 0,
  class: "prompt"
}
const _hoisted_13 = {
  key: 1,
  class: "form-box"
}
const _hoisted_14 = {
  key: 2,
  class: "form-box"
}
const _hoisted_15 = { class: "operating-box" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_elem_form = _resolveComponent("elem-form")!
  const _component_elem_icon = _resolveComponent("elem-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["step-box", { padding: !!_ctx.submitApi }]),
      onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onStepBoxScroll && _ctx.onStepBoxScroll(...args))),
      id: _ctx.id + '-step'
    }, [
      _createElementVNode("form", {
        class: "form-box",
        id: _ctx.id + '-form'
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.structure, (conf, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item-box step-item",
            key: idx,
            id: 'FromItemBox-' + conf.name,
            "data-step-id": 'StepItemBox-' + conf.name
          }, [
            (_ctx.getConditionValue(conf.where))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["item-base step-base", 'step-item-' + idx])
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.getStepNumber(idx)), 1),
                    _createElementVNode("p", _hoisted_7, _toDisplayString(conf.title), 1)
                  ]),
                  (conf.type === 'PASSWORD')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("div", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conf.data, (item, idx) => {
                            return (_openBlock(), _createBlock(_component_elem_form, {
                              index: idx,
                              key: idx,
                              data: item,
                              config: conf,
                              value: _ctx.value,
                              onChangeData: _ctx.onChangeValue
                            }, null, 8, ["index", "data", "config", "value", "onChangeData"]))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        (conf.prompt)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(conf.prompt), 1))
                          : _createCommentVNode("", true),
                        (!conf.list)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conf.data, (item, idx) => {
                                return (_openBlock(), _createBlock(_component_elem_form, {
                                  index: idx,
                                  key: idx,
                                  data: item,
                                  config: conf,
                                  value: _ctx.value,
                                  onChangeData: _ctx.onChangeValue
                                }, null, 8, ["index", "data", "config", "value", "onChangeData"]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getStepMap(conf.name), (sub, sub_idx) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "list-box",
                                  key: sub.key_id
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conf.data, (item, idx) => {
                                    return (_openBlock(), _createBlock(_component_elem_form, {
                                      entity: conf.name,
                                      index: sub_idx,
                                      key: sub.key_id + idx,
                                      data: item,
                                      config: conf,
                                      value: _ctx.value,
                                      onChangeData: _ctx.onChangeValue
                                    }, null, 8, ["entity", "index", "data", "config", "value", "onChangeData"]))
                                  }), 128)),
                                  _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "clear-button",
                                      onClick: ($event: any) => (_ctx.onChangeList('clear', conf.name, sub_idx))
                                    }, [
                                      _createVNode(_component_elem_icon, {
                                        class: "icon-box",
                                        name: "clear_red"
                                      })
                                    ], 8, _hoisted_16),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "add-button",
                                      onClick: ($event: any) => (_ctx.onChangeList('append', conf.name))
                                    }, [
                                      _createVNode(_component_elem_icon, {
                                        class: "icon-box",
                                        name: "add_blue"
                                      })
                                    ], 8, _hoisted_17)
                                  ])
                                ]))
                              }), 128))
                            ]))
                      ]))
                ], 2))
              : _createCommentVNode("", true)
          ], 8, _hoisted_4))
        }), 128))
      ], 8, _hoisted_3)
    ], 42, _hoisted_2),
    (!!_ctx.submitApi)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "submit-button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
        }, "提交"))
      : _createCommentVNode("", true)
  ]))
}